import MedicalSummaryButtonIcon from '../../assets/icons/Vector.svg?react'
import TooltipWrapper from './TooltipWrapper';
import { isLastStep } from '../../constants/formSteps';
import { useAddCaseFormContext } from '../../contexts/AddCaseFormContext';
import useCertifiedLifecareCompany from '../../hooks/useCertifiedLifecareCompany';
import XButton from '../common/XButton';

const GenerateDemandBtn = () => {
    const { presignedUrlGenerationCount, addCaseFormStep, handleNextClick, isDisableSubmitButton, submitBtnToolTipMsg } = useAddCaseFormContext();

    const isUploading = presignedUrlGenerationCount > 0;

    const isCertifiedLifecareCompany = useCertifiedLifecareCompany();

    const isDisabled = (isDisableSubmitButton && isLastStep(addCaseFormStep)) || isUploading || isCertifiedLifecareCompany;

    const isFinalStep = isLastStep(addCaseFormStep);

    return (
        <>
            <TooltipWrapper
                showTooltip={isFinalStep && submitBtnToolTipMsg}
                title={submitBtnToolTipMsg}
                variant="error"
            >
                <XButton
                    type="submit"
                    variant={isFinalStep ? 'primary' : 'link'}
                    onClick={handleNextClick}
                    disabled={isDisabled}
                >
                    {isFinalStep ?
                        <>
                            <MedicalSummaryButtonIcon className="mr-2" />
                            Generate Demand
                        </>
                        : <>Next<i className='ml-2 fa fa-arrow-right' /></>}
                </XButton>
            </TooltipWrapper>
        </>
    )
}

export default GenerateDemandBtn;